import { Loader } from '../loader/Loader';
import {
    SusyButtonProps,
    getButtonClassAccordingToSize,
    getButtonClassAccordingToKind,
} from './SusyButtonDefinitions';

const SusyButton = ({
    icon,
    text,
    onClickHandler,
    classes,
    dataTestId,
    htmlAttributes,
    fullWidth,
    kind,
    iconPosition = 'start',
    size = 'large',
    innerRef,
    loading,
    disabled,
}: SusyButtonProps) => {
    const iconIsDefined = icon !== undefined;

    const renderIcon = () => {
        if (!iconIsDefined) {
            return null;
        }

        return (
            <div className={'icon-holder mr-2 d-flex align-items-center'}>
                {icon}
            </div>
        );
    };

    return (
        <button
            ref={innerRef}
            className={`susy-button ${getButtonClassAccordingToKind(
                kind ?? 'primary'
            )} ${getButtonClassAccordingToSize(size ?? 'large')} ${
                fullWidth ? 'w-100' : ''
            } ${loading ? 'button-loader' : ''} ${classes ?? ''}`}
            onClick={onClickHandler}
            data-testid={dataTestId}
            type='button'
            disabled={disabled}
            {...htmlAttributes}
        >
            {!loading ? (
                <>
                    {iconIsDefined && iconPosition === 'start' && renderIcon()}
                    {text}
                    {iconIsDefined && iconPosition === 'end' && renderIcon()}
                </>
            ) : (
                <Loader />
            )}
        </button>
    );
};

export default SusyButton;
